import { once } from 'lodash';
import * as appLifecycleService from '../services/app-lifecycle-service';

export const APPLICATION_LOADED = 'application/LOADED';

const triggerFedopsAppLoaded = once(fedopsLogger => fedopsLogger.appLoaded());

export const applicationLoaded = () => (dispatch, getState, { fedopsLogger }) => {
  appLifecycleService.appLoaded({ logInSdk: true });
  fedopsLogger && triggerFedopsAppLoaded(fedopsLogger);
  return { type: APPLICATION_LOADED };
};



// WEBPACK FOOTER //
// ./app/actions/application-loaded.js